angular.
module("dx.webapp.accessibility").
controller("DxAccessibilityFlagsController", function AccessibilityFlagsController() {
	"use strict";

	var self = this;

	self.displayMode = self.displayMode || "line";

	self.usedAccessibility = function usedAccessibility() {
		return self.accessibilityFlags.spellcheck ||
		self.accessibilityFlags.audioFile ||
		self.accessibilityFlags.textToSpeech ||
		self.accessibilityFlags.extendedTime ||
		self.accessibilityFlags.immersiveReader;
	};
});
